import { AuthenticationError } from '@multiplier/lib-shared-types';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { showErrorToast } from './error-toast';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      // showErrorToast is default true unless explicitly set to false
      const shouldShowToast =
        typeof query.meta?.showErrorToast === 'function'
          ? query.meta.showErrorToast(error)
          : (query.meta?.showErrorToast ?? true);
      if (shouldShowToast) {
        // Only pass meta.errorMessage if explicitly provided, otherwise let showErrorToast extract from error
        const errorMessage = typeof query.meta?.errorMessage === 'string' ? query.meta.errorMessage : undefined;
        showErrorToast(error, errorMessage);
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      // showErrorToast is default true unless explicitly set to false
      const shouldShowToast = mutation.meta?.showErrorToast ?? true;
      if (shouldShowToast) {
        // Only pass meta.errorMessage if explicitly provided, otherwise let showErrorToast extract from error
        const errorMessage = typeof mutation.meta?.errorMessage === 'string' ? mutation.meta.errorMessage : undefined;
        showErrorToast(error, errorMessage);
      }
    },
  }),
  defaultOptions: {
    queries: {
      gcTime: Number.POSITIVE_INFINITY,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry 401s — the axios interceptor handles token refresh
        if (error instanceof AuthenticationError) {
          return false;
        }
        return failureCount < 3;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
